import { name } from "file-loader"

const newsDetail = {

}


export default {
  title: '新闻',
  tabs: [{
    title:'全部',
    en_title:'All',
    name:'9',
  },{
    title:'企业新闻',
    en_title:'Corporate news',
    name:'10',
  },{
    title:'企业声明',
    en_title:'Corporate statement',
    name:'11',
  },{
    title:'产品资讯',
    en_title:'Product information',
    name:'12',
  },
  {
    title:'产品业绩',
    en_title:'Product performance',
    name:13,
  },
  ],
  newsDetail,
}


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/newsPage.js